// extracted by mini-css-extract-plugin
export default {"footer-disclaimer":"footer-disclaimer--N41y2","footerDisclaimer":"footer-disclaimer--N41y2","title":"title--kZ2Kx","text":"text--CzI2u","blink":"blink--yeuBh"};